<template>
  <div class="legal-services-help-request-sent-page">
    <div v-if="pending"
         style="min-height: 20rem; position: relative">
      <BasePreloader/>
    </div>
    <div v-else-if="error"
         class="container">
      <ErrorView :code="error.code"
                 :title="error.message"
                 class="container-inner"/>
    </div>
    <div v-else-if="pageData"
         class="legal-services-help-request-sent-page__content-wrap  container">
      <div class="legal-services-help-request-sent-page__content  container-inner">
        <h1 class="legal-services-help-request-sent-page__title">
          {{
            $tLegalServicesRequestSent(`Your application is accepted and processed by our lawyers`)
          }}</h1>
        <div class="legal-services-help-request-sent-page__ico"></div>
        <div class="legal-services-help-request-sent-page__text  text">
          <p>{{ $tLegalServicesRequestSent('Please wait, we will reply to you soon.') }}
          </p>
        </div>
        <div class="legal-services-help-request-sent-page__thanks">
          {{ $tLegalServicesRequestSent('Thank you for contacting us!') }}
        </div>
        <router-link-modified :to="{name: 'vacancies'}"
                              class="legal-services-help-request-sent-page__btn  base-btn  base-btn--blue">
          <span class="base-btn__text">{{ $tLegalServicesRequestSent('Return to employment') }}</span>
          <BaseSvg name="ico-arrow-light"/>
        </router-link-modified>
      </div>
    </div>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import ErrorView from '@/components/ErrorView'

  export default {
    name: 'LegalServicesHelpRequestSentPage',
    components: {
      ErrorView
    },
    data() {
      return {
        error: null,
        pending: false,
        pageData: null,
      }
    },
    computed: {
      redirect() {
        return this.$route.fullPath
      }
    },
    methods: {
      send() {
        this.pending = true

        http.post('/api/services/legal/order ').then(({data}) => {
          if (data.data.error === 'USER_NOT_LOGGED') {
            this.$router.push({name: 'auth', query: {'for-credit': 'true', redirect: this.redirect}})
            return
          }

          this.pageData = data.data.data
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).catch((error) => {
          this.error = {
            code: error.response.status,
            message: error.response.data && error.response.data.message || error.message
          }
        }).finally(() => {
          this.pending = false
        })
      }
    },
    created() {
      this.send()
    }
  }
</script>

<style lang="less">

</style>
